import { render, staticRenderFns } from "./BirthValidationModal.vue?vue&type=template&id=475c0f5c&scoped=true"
import script from "./BirthValidationModal.vue?vue&type=script&lang=js"
export * from "./BirthValidationModal.vue?vue&type=script&lang=js"
import style0 from "./BirthValidationModal.vue?vue&type=style&index=0&id=475c0f5c&prod&scoped=true&lang=css"
import style1 from "./BirthValidationModal.vue?vue&type=style&index=1&id=475c0f5c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "475c0f5c",
  null
  
)

export default component.exports